import {React, observer, Fragment} from '@api'
import {Icon} from '@blueprintjs/core'
import {Tooltip2} from '@api'
import * as css from './CatalogNavigationButtons.css'
import {useCatalog} from '@stores'
import {PrimaryIconButton} from 'centric-ui-components'
import { Tooltip } from '@material-ui/core'


export const GoToPreviousCatalogItemButton = observer(function GoToPreviousCatalogItemButton() {
  const {strings, navigateToPreviousCatalogItem, canNavigateLeft} = useCatalog()
  return <Tooltip title={strings.previousCatalogItem} placement='bottom'>
    <PrimaryIconButton disabled={!canNavigateLeft} wrapperClassName={css.previousCatalogItem} icon={<Icon icon='arrow-left'/>} onClick={navigateToPreviousCatalogItem}/>
  </Tooltip>
})

export const GoToNextCatalogItemButton = observer(function GoToNextCatalogItemButton() {
  const {strings, navigateToNextCatalogItem, canNavigateRight} = useCatalog()
  return <Tooltip title={strings.nextCatalogItem} placement='bottom'>
    <PrimaryIconButton disabled={!canNavigateRight} wrapperClassName={css.nextCatalogItem} icon={<Icon icon='arrow-right'/>} onClick={navigateToNextCatalogItem}/>
  </Tooltip>
})

export const CatalogNavigationButtons = observer(function CatalogNavigationButtons() {
  const {canNavigateLeft, canNavigateRight, flexLayout: {flexEnabled, maximizedTab, isMaximized}, sidebar: {right: {showDetailsView}}} = useCatalog()


  return (flexEnabled && !isMaximized || maximizedTab?.component != 'catalog') ? null  // Todo - move this functionality into the flex layout tab menu instead  YFTS-9049
                                     : !showDetailsView ? null : !canNavigateLeft && !canNavigateRight ? null : (
    //<div className={css.root}>
    <Fragment>
      <GoToPreviousCatalogItemButton />
      <GoToNextCatalogItemButton />
    </Fragment>
  )
})



// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/CatalogNavigationButtons.tsx